import { Component, computed, inject, input, output } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { IconService } from '@unity/services/icon.service';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { QuickActionProps } from '@unity/utils/types';

@Component({
  selector: 'unity-button-download-shared',
  imports: [KENDO_BUTTON, KENDO_LOADER, ActionSharedComponent],
  templateUrl: './button-download-shared.component.html',
  styleUrl: './button-download-shared.component.scss',
})
export class ButtonDownloadSharedComponent {
  private readonly iconService = inject(IconService);

  protected clickEvent = output();
  protected downloadIcon = this.iconService.downloadLightIcon;

  public readonly $buttonText = input.required<string>({ alias: 'buttonText' });
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });
  public readonly $gridIconOnly = input<boolean>(false, { alias: 'gridIconOnly' });

  protected readonly $action = computed<QuickActionProps>(() => {
    const buttonText = this.$buttonText();
    return {
      actionName: buttonText,
      description: buttonText,
      icon: 'downloadIcon',
    };
  });

  protected onClick() {
    this.clickEvent.emit();
  }
}
